import {
	countryTransform,
	featuredIconTransform,
	flameIconTransform,
	longDateTransform,
	sharesTransform,
	shortDateTransform,
	sourceTransform,
	starIconTransform,
	tagTransform,
	typeIconTransform,
} from "lib/table/tableTransforms.js";

export const contentColumnsNoDuplicatesOrInteractions = [
	{
		name: "Date",
		id: "fdate",
		width: 60,
		fixed: true,
		transform: shortDateTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "Type",
		id: "type",
		width: 55,
		fixed: true,
		minWidth: 420,
		transform: typeIconTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "Source",
		id: "source",
		width: 180,
		fixed: true,
		minWidth: 380,
		transform: sourceTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "Title",
		id: "title",
		width: 10,
		fixed: false,
		// html: true,
		transform: tagTransform,
	},
];

export const defaultContentColumns = [
	{
		name: "Date",
		id: "fdate",
		width: 60,
		fixed: true,
		transform: shortDateTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "Type",
		id: "type",
		width: 55,
		fixed: true,
		minWidth: 420,
		transform: typeIconTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "Source",
		id: "source",
		width: 120,
		fixed: true,
		minWidth: 380,
		transform: sourceTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "Title",
		id: "title",
		width: 10,
		fixed: false,
		// html: true,
		transform: tagTransform,
	},
	{
		name: "Duplicates",
		id: "dupCount",
		width: 95,
		fixed: true,
		minWidth: 460,
		disableSort: true,
		transform: sharesTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "Interactions",
		id: "shares",
		width: 110,
		fixed: true,
		minWidth: 500,
		transform: sharesTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "",
		id: "fakeIDforFlame",
		width: 20,
		fixed: true,
		minWidth: 500,
		disableSort: true,
		transform: flameIconTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
];

export const noDuplicatesContentColumns = [
	{
		name: "Date",
		id: "fdate",
		width: 60,
		fixed: true,
		transform: shortDateTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "Type",
		id: "type",
		width: 55,
		fixed: true,
		minWidth: 420,
		transform: typeIconTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "Source",
		id: "source",
		width: 120,
		fixed: true,
		minWidth: 380,
		transform: sourceTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "Title",
		id: "title",
		width: 10,
		fixed: false,
		// html: true,
		transform: tagTransform,
	},
	{
		name: "Interactions",
		id: "shares",
		width: 110,
		fixed: true,
		minWidth: 500,
		transform: sharesTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "",
		id: "fakeIDforFlame",
		width: 20,
		fixed: true,
		minWidth: 500,
		disableSort: true,
		transform: flameIconTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
];

export const dateTypeTitleSharesContentColumns = [
	{
		name: "Date",
		id: "fdate",
		width: 60,
		fixed: true,
		transform: shortDateTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "Type",
		id: "type",
		width: 55,
		fixed: true,
		minWidth: 420,
		transform: typeIconTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "Title",
		id: "title",
		width: 10,
		fixed: false,
		// html: true,
		transform: tagTransform,
	},
	{
		name: "Interactions",
		id: "shares",
		width: 110,
		fixed: true,
		minWidth: 500,
		transform: sharesTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "",
		id: "fakeIDforFlame",
		width: 20,
		fixed: true,
		minWidth: 500,
		disableSort: true,
		transform: flameIconTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
];


export const contentColumnsGECOnly = [
	{
		name: "Date",
		id: "fdate",
		width: 60,
		fixed: true,
		transform: shortDateTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "CO.",
		id: "location",
		width: 45,
		fixed: true,
		minWidth: 430,
		transform: countryTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "Type",
		id: "type",
		width: 55,
		fixed: true,
		minWidth: 500,
		transform: typeIconTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "Source",
		id: "source",
		width: 120,
		fixed: true,
		minWidth: 380,
		transform: sourceTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	// {
	// 	name: "Featured",
	// 	id: "featured",
	// 	width: 35,
	// 	fixed: true,
	// 	minWidth: 470,
	// 	headerTransform: starIconTransform,
	// 	transform: featuredIconTransform,
	// },
	{
		name: "Title",
		id: "title",
		width: 10,
		fixed: false,
		// html: true,
		transform: tagTransform,
	},
	{
		name: "Interactions",
		id: "shares",
		width: 110,
		fixed: true,
		minWidth: 580,
		transform: sharesTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "",
		id: "fakeIDforFlame",
		width: 20,
		fixed: true,
		minWidth: 580,
		disableSort: true,
		transform: flameIconTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
];

export const noTypeNoDuplicatesContentColumns = [
	{
		name: "Date",
		id: "fdate",
		width: 65,
		fixed: true,
		transform: shortDateTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "Source",
		id: "source",
		width: 130,
		fixed: true,
		minWidth: 380,
		transform: sourceTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "Title",
		id: "title",
		width: 10,
		fixed: false,
		// html: true,
		transform: tagTransform,
	},
	{
		name: "Interactions",
		id: "shares",
		width: 110,
		fixed: true,
		minWidth: 500,
		transform: sharesTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "",
		id: "fakeIDforFlame",
		width: 20,
		fixed: true,
		minWidth: 500,
		disableSort: true,
		transform: flameIconTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
];

export const noTypeContentColumns = [
	{
		name: "Date",
		id: "fdate",
		width: 90,
		fixed: true,
		transform: longDateTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "Source",
		id: "source",
		width: 130,
		fixed: true,
		minWidth: 380,
		transform: sourceTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "Title",
		id: "title",
		width: 10,
		fixed: false,
		// html: true,
		transform: tagTransform,
	},
	{
		name: "Duplicates",
		id: "dupCount",
		width: 100,
		fixed: true,
		minWidth: 460,
		disableSort: true,
		transform: sharesTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "Interactions",
		id: "shares",
		width: 110,
		fixed: true,
		minWidth: 500,
		transform: sharesTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "",
		id: "fakeIDforFlame",
		width: 20,
		fixed: true,
		minWidth: 500,
		disableSort: true,
		transform: flameIconTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
];

export const noTypeNoInteractionsContentColumns = [
	{
		name: "Date",
		id: "fdate",
		width: 65,
		fixed: true,
		transform: shortDateTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "Source",
		id: "source",
		width: 130,
		fixed: true,
		minWidth: 380,
		transform: sourceTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "Title",
		id: "title",
		width: 10,
		fixed: false,
		// html: true,
		transform: tagTransform,
	},
	{
		name: "Duplicates",
		id: "dupCount",
		width: 100,
		fixed: true,
		minWidth: 460,
		disableSort: true,
		transform: sharesTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "",
		id: "fakeIDforFlame",
		width: 20,
		fixed: true,
		minWidth: 500,
		disableSort: true,
		transform: flameIconTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
];

export const noSharesContentColumns = [
	{
		name: "Date",
		id: "fdate",
		width: 60,
		fixed: true,
		transform: shortDateTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "Type",
		id: "type",
		width: 55,
		fixed: true,
		minWidth: 420,
		transform: typeIconTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "Source",
		id: "source",
		width: 120,
		fixed: true,
		minWidth: 380,
		transform: sourceTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "Title",
		id: "title",
		width: 10,
		fixed: false,
		// html: true,
		transform: tagTransform,
	},
];

export const vzlaContentColumns = [
	{
		name: "Date",
		id: "fdate",
		width: 60,
		fixed: true,
		transform: shortDateTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "Source",
		id: "source",
		width: 130,
		fixed: true,
		minWidth: 380,
		transform: sourceTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "Title",
		id: "title",
		width: 10,
		fixed: false,
		// html: true,
		transform: tagTransform,
	},
	{
		name: "Duplicates",
		id: "dupCount",
		width: 95,
		fixed: true,
		minWidth: 460,
		disableSort: true,
		transform: sharesTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
];

export const baseContentColumns = [
	{
		name: "Date",
		id: "fdate",
		width: 65,
		fixed: true,
		transform: shortDateTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "Source",
		id: "source",
		width: 150,
		fixed: true,
		minWidth: 380,
		transform: sourceTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "Title",
		id: "title",
		width: 10,
		fixed: false,
		// html: true,
		transform: tagTransform,
	},
];

export const contentColumnsAus22Only = [
	{
		name: "Date",
		id: "fdate",
		width: 60,
		fixed: true,
		transform: shortDateTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "CO.",
		id: "location",
		width: 55,
		fixed: true,
		minWidth: 600,
		transform: countryTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "Type",
		id: "type",
		width: 55,
		fixed: true,
		minWidth: 500,
		transform: typeIconTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "Source",
		id: "source",
		width: 120,
		fixed: true,
		minWidth: 380,
		transform: sourceTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	// {
	// 	name: "Featured",
	// 	id: "featured",
	// 	width: 35,
	// 	fixed: true,
	// 	minWidth: 470,
	// 	headerTransform: starIconTransform,
	// 	transform: featuredIconTransform,
	// },
	{
		name: "Title",
		id: "title",
		width: 10,
		fixed: false,
		// html: true,
		transform: tagTransform,
	},
	{
		name: "Duplicates",
		id: "dupCount",
		width: 95,
		fixed: true,
		minWidth: 460,
		disableSort: true,
		transform: sharesTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "Interactions",
		id: "shares",
		width: 110,
		fixed: true,
		minWidth: 580,
		disableSort: true,
		transform: sharesTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "",
		id: "fakeIDforFlame",
		width: 20,
		fixed: true,
		minWidth: 580,
		disableSort: true,
		transform: flameIconTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
];

export const platform2023ColumnsNoInteractions = [
	{
		name: "Date",
		id: "fdate",
		width: 60,
		fixed: true,
		transform: shortDateTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "CO.",
		id: "location",
		width: 55,
		fixed: true,
		minWidth: 600,
		transform: countryTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "Type",
		id: "type",
		width: 55,
		fixed: true,
		minWidth: 500,
		transform: typeIconTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "Source",
		id: "source",
		width: 120,
		fixed: true,
		minWidth: 380,
		transform: sourceTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	// {
	// 	name: "Featured",
	// 	id: "featured",
	// 	width: 35,
	// 	fixed: true,
	// 	minWidth: 470,
	// 	headerTransform: starIconTransform,
	// 	transform: featuredIconTransform,
	// },
	{
		name: "Title",
		id: "title",
		width: 10,
		fixed: false,
		// html: true,
		transform: tagTransform,
	},
	{
		name: "Duplicates",
		id: "dup",
		width: 95,
		fixed: true,
		minWidth: 460,
		disableSort: true,
		transform: sharesTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
	{
		name: "",
		id: "fakeIDforFlame",
		width: 20,
		fixed: true,
		minWidth: 580,
		disableSort: true,
		transform: flameIconTransform,
		className: "notranslate",
		rowClassName: "notranslate",
	},
];